<div appFavIcon class="container">
    <header>
        <mat-toolbar role="banner" color="primary">
            <ng-template #header_logo>
                @if ( (brandingService.brandingSubject | async)?.logoUrl; as
                logo ) {
                <img
                    alt="{{ clientName$ | async }}"
                    aria-label="Company logo"
                    src="{{ logo }}"
                    (error)="errorHandler($event)"
                />
                } @else {
                <img
                    class="w-60"
                    aria-label="Code Technology logo"
                    alt="Code Technology logo"
                    src="assets/img/code_logo.svg"
                />
                }
            </ng-template>
            @if ( faqLogoRedirectLink$ | async; as href ) {
            <a [href]="href" target="_blank">
                <ng-container *ngTemplateOutlet="header_logo"></ng-container>
            </a>
            } @else {
            <ng-container *ngTemplateOutlet="header_logo"></ng-container>
            }
        </mat-toolbar>
    </header>

    <main role="main">
        <div class="wrapper">
            <ng-container>
                @if ( (brandingService.brandingSubject | async)?.logoUrl &&
                validFaq === true) {
                <div id="faq-body" [innerHTML]="content"></div>
                } @else {
                <div
                    class="wrapper"
                    style="
                        min-height: calc(
                            100vh - 10.875rem - 1.25rem - 1.5rem - 0.25rem
                        );
                    "
                >
                    <div class="content-status-page">
                        <div class="paragraph" [innerHTML]="content"></div>
                    </div>
                </div>
                }
            </ng-container>
        </div>
    </main>

    <footer role="contentinfo">
        <section
            role="region"
            [innerHtml]="
                $safeNavigationMigration(
                    (metaDataService.metaData$ | async)?.copyright
                )
            "
            aria-label="Copyright CODE Technology"
        ></section>

        <a
            href="https://www.w3.org/WAI/WCAG2AA-Conformance"
            title="Explanation of WCAG 2 Level AA conformance"
            target="_blank"
        >
            <img
                aria-label="Level AA conformance, W3C WAI Web Content Accessibility Guidelines 2.1"
                src="https://www.w3.org/WAI/WCAG21/wcag2.1AA-blue-v"
                alt="Level AA conformance, W3C WAI Web Content Accessibility Guidelines 2.1"
            />
        </a>
    </footer>
</div>
